import {
  DefaultPaymentPeriod,
  RevenueRecognitionOptions as RROptions
} from "@/data/enums/products";
import i18n from "@/i18n";

const PaymentPeriodsMap = () => {
  return {
    [DefaultPaymentPeriod.INHERIT_FROM_BRAND]: {
      id: DefaultPaymentPeriod.INHERIT_FROM_BRAND,
      label: i18n.t("_.payment_periods.inherit_from_brand")
    },
    [DefaultPaymentPeriod.HIGHEST_PRICE]: {
      id: DefaultPaymentPeriod.HIGHEST_PRICE,
      label: i18n.t("_.payment_periods.highest_price")
    },

    [DefaultPaymentPeriod.LOWEST_PRICE]: {
      id: DefaultPaymentPeriod.LOWEST_PRICE,
      label: i18n.t("_.payment_periods.lowest_price")
    },

    [DefaultPaymentPeriod.LOWEST_MONTHLY_PRICE]: {
      id: DefaultPaymentPeriod.LOWEST_MONTHLY_PRICE,
      label: i18n.t("_.payment_periods.lowest_monthly_price")
    }
  };
};

const RevenueRecognitionOptionsMap = () => {
  return {
    [RROptions.IMMEDIATELY]: {
      id: RROptions.IMMEDIATELY,
      label: i18n.t("_sentence.catalogue.recognise_revenue_immediately")
    },

    [RROptions.OVER_BILLING_CYCLE]: {
      id: RROptions.OVER_BILLING_CYCLE,
      label: i18n.t("_sentence.catalogue.recognise_revenue_over_cycle")
    }
  };
};

export { PaymentPeriodsMap, RevenueRecognitionOptionsMap };
